import { LogIn, ShieldCheck, Zap } from 'lucide-react'

import { Anchor } from '@/components/ui/Anchor'
import { Reveal } from '../marketing/components/Reveal'
import { ValueProp } from '../marketing/components/ValueProp'

const VALUE_PROPS = [
  {
    key: 'competitive-quotes',
    icon: <Zap />,
    title: 'Competitive quotes, fast',
    body: 'We work with top insurance providers to find the best quotes for your business.',
  },
  {
    key: 'safety-compliance',
    icon: <ShieldCheck />,
    title: 'Year-round safety & compliance support',
    body: 'We flag risks before they hit your premiums, not after.',
  },
  {
    key: 'policy-management',
    icon: <LogIn />,
    title: 'Seamless policy management',
    body: 'We make it easy to get what you need to keep moving.',
  },
]

export function IntelligentInsuranceSection() {
  return (
    <section className="bg-ink-800 px-5.5 py-24 lg:py-32">
      <div className="mx-auto max-w-(--maxw)">
        <Reveal className="flex flex-col items-start gap-3.5">
          <h2 className="h2 text-pretty text-white">Intelligent trucking insurance</h2>
          <Anchor
            href="https://blog.cai.ai/how-cai-is-using-ai-to-fix-trucking-insurance"
            className="text-ink-300 border-b border-white/30 pb-1.5 text-lg no-underline transition-colors duration-150 hover:border-white hover:text-white"
          >
            Learn more about how Cai uses AI.
          </Anchor>
        </Reveal>
        <Reveal delay={120}>
          <div className="mt-11 grid grid-cols-3 border border-white/15 max-md:grid-cols-1">
            {VALUE_PROPS.map((prop) => (
              <ValueProp
                key={prop.key}
                onDark
                icon={prop.icon}
                title={prop.title}
                className="border-r border-white/15 px-8 py-10 last:border-r-0 max-md:border-r-0 max-md:border-b max-md:last:border-b-0"
              >
                {prop.body}
              </ValueProp>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  )
}
